export const CLIENT_MEASURE_STATUS_COMPLETED = 0
export const CLIENT_MEASURE_STATUS_NOT_COMPLETED = 1
export const MEASURE_STATUS_SCHEDULED = 0
export const MEASURE_STATUS_COMPLETED = 1
export const MEASURE_STATUS_INCOMPLETE = 2
export const MEASURE_STATUS_SKIPPED = 3
